import type { MonitoringAiCreditResponse } from "../../shared/aiUsageRecords";
import { monitoringAiUsagePath } from "../lib/apiPaths";
import { managedAiLifetimeCreditCents } from "../lib/session";
import { useRevisionedJson } from "./useRevisionedJson";

export type ManagedAiCredit = { spentUsd: number; limitUsd: number };

// Spend comes from the Monitoring endpoint rather than sync, so it refetches
// whenever `revision` changes, such as when a chat turn starts or finishes.
export function useManagedAiCredit({
  enabled,
  revision,
}: {
  enabled: boolean;
  revision?: unknown;
}): ManagedAiCredit | null {
  const creditCents = managedAiLifetimeCreditCents();
  const { data } = useRevisionedJson<MonitoringAiCreditResponse>(
    monitoringAiUsagePath(),
    enabled && creditCents != null ? "only=credit" : null,
    revision
  );
  return creditCents != null && data
    ? { spentUsd: data.managedAiCreditSpentUsd, limitUsd: creditCents / 100 }
    : null;
}
